import { render } from "./Permissions.vue?vue&type=template&id=53b54f30&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=53b54f30&scoped=true&lang=css"

import exportComponent from "/Users/imac/projects/java/marketplace/wallet/wallet.console.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b54f30"]])

export default __exports__